import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { IDockerSiteData } from "types/api/webAppApiInterface";

import ChangeEasyappointmentConfig from "../actions/appointmentActions/ChangeEasyappointmentConfig";

const EasyappointmentConf = ({ siteData }: { siteData: IDockerSiteData }): ReactElement => {
 return (
  <Stack textAlign="left" pt={2}>
   <Stack direction="row" alignItems="center" spacing={1} pb={1}>
    <Typography fontWeight="bold" variant="unboundedTitle" fontSize={14}>
     SMTP
    </Typography>
   </Stack>
   <Stack direction="row">
    <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
     <FormattedMessage id="docker.website.fromName" />
    </Typography>
    <Typography variant="subtitle2">{`${
     siteData.easyappointments?.config.easyappointments_from_name || "not selected"
    }`}</Typography>
   </Stack>
   <Stack direction="row">
    <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
     <FormattedMessage id="docker.website.fromAddress" />
    </Typography>
    <Typography variant="subtitle2">{`${
     siteData.easyappointments?.config.easyappointments_from_address || "not selected"
    }`}</Typography>
   </Stack>
   <Stack direction="row">
    <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
     <FormattedMessage id="docker.website.replyTo" />
    </Typography>
    <Typography variant="subtitle2">{`${
     siteData.easyappointments?.config.easyappointments_reply_to || "not selected"
    }`}</Typography>
   </Stack>
   <Stack direction="row">
    <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
     <FormattedMessage id="docker.website.smtpName" />
    </Typography>
    <Typography variant="subtitle2">{`${
     siteData.easyappointments?.config.easyappointments_smtp_user || "not selected"
    }`}</Typography>
   </Stack>
   <Stack direction="row">
    <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
     <FormattedMessage id="docker.website.smtpPassword" />
    </Typography>
    <Typography variant="subtitle2">{`${
     siteData.easyappointments?.config.easyappointments_smtp_pass || "not selected"
    }`}</Typography>
   </Stack>
   <Stack direction="row">
    <Typography fontWeight="bold" variant="subtitle2" minWidth={160}>
     <FormattedMessage id="docker.website.smtpPort" />
    </Typography>
    <Typography variant="subtitle2">{`${
     siteData.easyappointments?.config.easyappointments_smtp_port || "not selected"
    }`}</Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack direction="row" alignItems="center" spacing={1}>
    <Typography fontWeight="bold" variant="unboundedTitle" fontSize={14}>
     Actions
    </Typography>
   </Stack>
   <Stack direction="row">
    <ChangeEasyappointmentConfig id={siteData.id} />
   </Stack>
  </Stack>
 );
};

export default EasyappointmentConf;
